export default () => ({
  showDrawer: false,
  activeTab: null,
});
